import { StaticImageData } from 'next/image';

// https://stripe.com/docs/card-brand-choice#card-brands
// https://www.dreamstale.com/free-download-payment-method-vector-icons/
//
// note: I have not been able to reproduce a 'Cartes Bancaires' card
// from cardDetails.brand by using CB test card #, so omitting the usage for now
import amex from './amex.png';
import diners from './diners.png';
import discover from './discover.png';
import jcb from './jcb.png';
import mastercard from './mastercard.png';
import visa from './visa.png';
import unionpay from './unionpay.png';

import defaultCard from './default-card.svg';
import paypal from './paypal.svg';

export const paymentIcons: { [key: string]: StaticImageData } = {
  'american express': amex, // cardDetails.brand comes back as 'american express'
  diners,
  discover,
  jcb,
  mastercard,
  visa,
  unionpay,
  defaultCard,
  paypal,
};
